import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { LogIn, Loader2, Eye, EyeOff, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card } from '../ui/card';
import { toast } from 'sonner';
import { BACKEND_URL, errorMessage, storeSession } from '../../lib/easerApi';

const LOGO = 'https://customer-assets.emergentagent.com/job_easers-pro/artifacts/j38s08lp_LOGOSITE.png';

export function EaserLogin({ onLogin }) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!login.trim() || !password) return;
    setLoading(true);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/easer/login`, { login: login.trim(), password });
      storeSession(res.data.token, res.data.user);
      toast.success(`Bonjour ${res.data.user.firstname || res.data.user.name} !`);
      onLogin(res.data.user);
    } catch (err) {
      toast.error(errorMessage(err, 'Connexion impossible'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[linear-gradient(160deg,hsla(195,20%,97%,1)_0%,hsla(182,40%,92%,1)_60%,hsla(195,20%,97%,1)_100%)]" data-testid="easer-login-page">
      <div className="max-w-md w-full mx-auto px-4 pt-6 pb-10 flex-1 flex flex-col">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-6" data-testid="easer-back-home">
          <ArrowLeft className="h-4 w-4" /> Retour au site
        </Link>
        <div className="flex flex-col items-center text-center mb-8">
          <img src={LOGO} alt="Ptitservices.com" className="h-14 w-auto rounded-xl mb-4" />
          <h1 className="font-['Space_Grotesk'] text-2xl font-semibold tracking-tight">Espace Easer</h1>
          <p className="text-sm text-muted-foreground mt-1">Planning, pointage, congés et documents — connecté à Dolibarr.</p>
        </div>
        <Card className="p-6 shadow-lg border-border">
          <form onSubmit={submit} className="space-y-4" data-testid="easer-login-form">
            <div className="space-y-1.5">
              <Label htmlFor="easer-login">Identifiant Dolibarr</Label>
              <Input id="easer-login" autoComplete="username" autoCapitalize="none" value={login} onChange={(e) => setLogin(e.target.value)} placeholder="prenom.nom" className="h-11" data-testid="easer-login-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="easer-password">Mot de passe Dolibarr</Label>
              <div className="relative">
                <Input id="easer-password" type={show ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 pr-11" data-testid="easer-password-input" />
                <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-muted-foreground hover:text-foreground" aria-label={show ? 'Masquer' : 'Afficher'} data-testid="easer-password-toggle">
                  {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
              </div>
            </div>
            <Button type="submit" size="lg" className="w-full h-11 bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white" disabled={loading || !login.trim() || !password} data-testid="easer-login-submit">
              {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <LogIn className="h-4 w-4 mr-2" />}
              Se connecter
            </Button>
          </form>
        </Card>
        <p className="text-xs text-muted-foreground text-center mt-6 leading-relaxed">
          Utilisez exactement les mêmes identifiant et mot de passe que dans Dolibarr : vos pointages alimentent ainsi MySchedule. Mot de passe oublié ? Contactez l'agence au 03 74 47 47 82.
        </p>
      </div>
    </div>
  );
}
